// extracted by mini-css-extract-plugin
module.exports = {"HomePage__container":"HomePage_HomePage__container__0XGts","HomePage__module":"HomePage_HomePage__module__y2LE0"};